import React from 'react'
import Headline from './components/headline/Main'

function Home() {
  return (
    <div>
     <Headline/>
    </div>
  )
}

export default Home